export const AUTH_ERROR_MESSAGES = {
  "zh_TW": {
    "credentials": "帳號或密碼不正確",
    "disabled": "會員帳號已停用",
    "accountExists": "帳號已註冊",
    "emailExists": "電子郵件已註冊",
    "phoneExists": "手機號碼已註冊",
    "emailMissing": "電子郵件尚未註冊",
    "phoneMissing": "手機號碼尚未註冊",
    "codeExpired": "驗證碼不存在或已過期",
    "codeIncorrect": "驗證碼不正確",
    "tooFrequent": "請稍後再試",
    "sendFailed": "驗證碼發送失敗",
    "touristsDisabled": "遊客試玩入口已關閉",
    "inviterInvalid": "邀請碼不正確",
    "generic": "操作失敗，請稍後再試。"
  },
  "zh_CN": {
    "credentials": "账号或密码不正确",
    "disabled": "会员账号已停用",
    "accountExists": "账号已注册",
    "emailExists": "电子邮箱已注册",
    "phoneExists": "手机号码已注册",
    "emailMissing": "电子邮箱尚未注册",
    "phoneMissing": "手机号码尚未注册",
    "codeExpired": "验证码不存在或已过期",
    "codeIncorrect": "验证码不正确",
    "tooFrequent": "请稍后再试",
    "sendFailed": "验证码发送失败",
    "touristsDisabled": "游客试玩入口已关闭",
    "inviterInvalid": "邀请码不正确",
    "generic": "操作失败，请稍后再试。"
  },
  "en_US": {
    "credentials": "Incorrect account or password",
    "disabled": "Member account is disabled",
    "accountExists": "Account is already registered",
    "emailExists": "Email is already registered",
    "phoneExists": "Phone number is already registered",
    "emailMissing": "Email is not registered",
    "phoneMissing": "Phone number is not registered",
    "codeExpired": "Verification code is missing or expired",
    "codeIncorrect": "Incorrect verification code",
    "tooFrequent": "Please try again later",
    "sendFailed": "Failed to send verification code",
    "touristsDisabled": "Tourist trial registration is disabled",
    "inviterInvalid": "Invalid invitation code",
    "generic": "Unable to complete the action. Please try again."
  }
};
